import $ from 'jquery';
import slick from 'slick-carousel';

class Carousel {
    constructor(target, settings) {
        this.carouselContainer = target;
        this.settings = settings || {
            mobileFirst: true,
            arrows: false,
            dots: true,
            centermode: false,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        arrows: true,
                        dots: true
                    }
                }
            ]
        };
    }

    initPageBuilder() {
		this.carouselWidget();
	}

    init() {
        $(this.carouselContainer).slick(this.settings);
    }
    
	carouselWidget() {
		if ($('.page-builder.slider-nav').length === 0) return;
		$('.page-builder.slider-for').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			asNavFor: '.slider-nav'
		});

		$('.page-builder.slider-nav').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			asNavFor: '.slider-for',
			dots: false,
			infinite: true,
			arrows: true,
			focusOnSelect: true,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 750,
					settings: {
						slidesToShow: 4
					}
				}
			]
		});
	}
}

export default Carousel;